import { Box, InputBase } from "@mui/material";
import { FC, forwardRef, useEffect, useState } from "react";
import { DefaultButton } from "./default-button.component";
import ModalComponent from "./modal.component";
import { styled, alpha } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import { GetAllDto } from "../Shared/dto/get-all-dto";
import { ContactService } from "../Services/contact.service";
import Tasks from "../Pages/Tasks/Tasks";
import { useLoading } from "../Shared/services/loading-context";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import InputTextField from "./text-field.component";
import useConstant from "use-constant";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import { useAsync } from "react-async-hook";


export const ContactModal: FC<{
  onSelectCustomer: (data?: any) => void;
  isCustomerModalOpen: boolean;
  redirectToContact:()=> void;
}> = (props) => {
  const [isCustomerModalOpen, setIsCustomerModalOpen] =
    useState<boolean>(false);
  const [contactName, setContactName] = useState<any[]>([]);
  const { loading, setLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    setInputText(null);
    if (props.isCustomerModalOpen) openContactModal();
    else setIsCustomerModalOpen(false);
  }, [props.isCustomerModalOpen]);

  const customerModalStyle = {
    border: "none",
    width: "430px",
    height: "469px",
    maxHeight: "100vh",
    maxWidth: "100vw",
    // left: "771px",
    // top: "299px",
    background: "#FFFFFF",
    boxShadow: "0px 0px 10px 3px rgb(2 4 4 / 7%)",
    borderRadius: "15px",
    padding: 0,
    overflowY: "auto",
  };

  const openContactModal = async (searchQuery?: string) => {
    if (props.isCustomerModalOpen) {
      setIsCustomerModalOpen(true);
    }
    const getAllDto = new GetAllDto("name");
    if (searchQuery) {
      getAllDto.searchQuery = searchQuery;
    }
    setLoading(true);
    const response = await ContactService.getContactsForModal(getAllDto);
    setLoading(false);
    if (response.success) {
      setContactName(response.data);
    } else
      enqueueSnackbar(response.message ?? "Internal server error", {
        variant: "error",
      });
  };

  const navigate = useNavigate();



  const useDebouncedSearch = (searchFunction: any) => {
    // Handle the input text state
    const [inputText, setInputText] = useState<string | null>("");

    // Debounce the original search async function
    const debouncedSearchFunction = useConstant(() =>
      AwesomeDebouncePromise(searchFunction, 500)
    );

    // The async callback is run each time the text changes,
    // but as the search function is debounced, it does not
    // fire a new request on each keystroke
    const searchResults = useAsync(async () => {
      debouncedSearchFunction(inputText);
    }, [debouncedSearchFunction, inputText]);

    // Return everything needed for the hook consumer
    return {
      inputText,
      setInputText,
      searchResults,
    };
  };

  const useSearchStarwarsHero = () =>
    useDebouncedSearch((inputText: any) => {
      openContactModal(inputText);
    });
  const { inputText, setInputText, searchResults } = useSearchStarwarsHero();

  const onSearch = (e: any) => {
    setInputText(e.target.value);
  };
  const getContactData = (data: any) => {
    props.onSelectCustomer(data)
  };

  return (
    <div>
      <ModalComponent
        // title="Select Customer"
        style={customerModalStyle}
        isModalOpen={isCustomerModalOpen}
        customHeader={true}
        hideModal={props.onSelectCustomer}
      >
        <div className="selection-modal">
          <span className="selectCustomerText">Select Contact</span>
          <DefaultButton onClick={props.redirectToContact}>
            Add New Contact
          </DefaultButton>
        </div>
        <div className="contact-modal-search">
          <InputTextField
            className="contact-modal-search-input"
            value={inputText ?? ""}
            autoComplete="off"
            // label="Invoice No"
            placeholder="Search..."
            InputLabelProps={{ style: { fontFamily: "GilroyBold" } }}
            onChange={(e) => onSearch(e)}
          />
        </div>

        {contactName.map((currElem) => {
  return (
    <Box
      key={currElem._id || currElem.id || currElem.mobileNo} // ✅ Add unique key here
      onClick={() => props.onSelectCustomer(currElem)}
      className="d-flex justify-content-between"
      sx={{
        margin: "auto 20px",
        marginTop: "15px",
        padding: "16px 20px",
        border: "2px solid #E8E8E8",
        position: "relative",
        cursor: "pointer",
        borderRadius: "10px",
      }}
    >
      <div>
        <span className="modalListName">{currElem.name}</span>
        <span className="modalListContactType">{currElem.contactType}</span>
      </div>
      <div>
        <span className="modalListNumber">{currElem.mobileNo}</span>
      </div>
    </Box>
  );
})}

      </ModalComponent>
      {/* <Tasks contactName={contactName} /> */}
    </div>
  );
};
